/**
 * Color Scheme Constants
 * Adobe Color Theme - "Culture" Theme
 */

export const COLORS = {
  primary: {
    dark: '#427300',      // Dark Olive - Primary headings & text
    light: '#85BF35',     // Lime Green - Badges, highlights & buttons
    accent: '#FDFFC6',    // Light Cream - Backgrounds & accents
  },
  secondary: {
    taupe: '#737154',     // Taupe - Secondary text & labels
    gold: '#BFAD6A',      // Muted Gold - Borders & dividers
  },
};

/**
 * Category Colors Map
 */
export const CATEGORY_COLORS = {
  Grain: { bg: '#85BF35', text: '#ffffff' },
  Pulse: { bg: '#427300', text: '#ffffff' },
  Oilseed: { bg: '#BFAD6A', text: '#ffffff' },
  Fruit: { bg: '#737154', text: '#ffffff' },
  Flower: { bg: '#85BF35', text: '#ffffff' },
  Spice: { bg: '#427300', text: '#ffffff' },
  Vegetable: { bg: '#85BF35', text: '#ffffff' },
  General: { bg: '#737154', text: '#ffffff' },
};

/**
 * Common Styles
 */
export const COMMON_STYLES = {
  card: {
    background: '#ffffff',
    border: `1px solid ${COLORS.secondary.gold}`,
    shadow: '0 12px 24px rgba(66, 115, 0, 0.06)',
  },
  button: {
    primary: {
      background: COLORS.primary.light,
      color: '#ffffff',
    },
    secondary: {
      background: COLORS.primary.dark,
      color: '#ffffff',
    },
  },
  text: {
    primary: COLORS.primary.dark,
    secondary: COLORS.secondary.taupe,
  },
  border: COLORS.secondary.gold,
  divider: COLORS.primary.accent,
};
